/* eslint-disable react-hooks/rules-of-hooks */
import { Box, Flex, IconButton, Text, Tooltip, Icon } from '@chakra-ui/react';
import { FC } from 'react';
import { BsBoxArrowUpRight, BsGear } from 'react-icons/bs';
import { useHistory } from 'react-router-dom';
import { FaExclamationCircle } from 'react-icons/fa';
import useAuth from '../../../../hooks/useAuth';
import { Page } from '../../../../shared/models/page';

type PageListItemProps = {
  page: Page;
  onPageItemToEdit?: (page: Page) => void;
};

const PageListItem: FC<PageListItemProps> = ({ page, onPageItemToEdit }) => {
  const history = useHistory();

  const toEdit = () => {
    if (onPageItemToEdit) onPageItemToEdit(page);
  };

  const { nonEditablePages } = useAuth();

  return (
    <Box
      as="div"
      textAlign="left"
      bg="whiteAlpha.700"
      p="4"
      px="6"
      maxH="60px"
      rounded="lg"
      boxShadow="md"
      transition="all .2s ease-in-out"
      _hover={{ pl: '8' }}
      _focus={{ pl: '8' }}
    >
      <Flex justifyContent="space-between" alignItems="center" h="full">
        <Flex direction="column" alignContent="flex-start">
          {page.vtex_query && (
            <Text opacity="0.6" fontStyle="italic" fontSize="xs">
              vitrine
            </Text>
          )}
          <Text>{page.name}</Text>
        </Flex>
        <Flex gridGap={2}>
          <IconButton
            aria-label="show-page"
            rounded="md"
            size="xs"
            bg="transparent"
            color="blue.500"
            title={`Ir para o conteúdo da página ${page.name}`}
            icon={<BsBoxArrowUpRight size={16} />}
            _hover={{}}
            onClick={() => history.push(`/screens/${page.slug}`)}
          />
          {!nonEditablePages?.includes(page.slug) ? (
            <IconButton
              aria-label="edit-page"
              rounded="md"
              size="xs"
              bg="transparent"
              color="gray"
              title={`Editar ${page.name}`}
              icon={<BsGear size={16} />}
              onClick={toEdit}
              _hover={{}}
            />
          ) : (
            <Tooltip
              hasArrow
              label="Está é uma página não editável, para alterar isso, navegue até a página de Admin caso tenha permissão para esta ação!"
            >
              <span>
                <Icon w={5} h={5} as={FaExclamationCircle} color="blue.500" />
              </span>
            </Tooltip>
          )}
        </Flex>
      </Flex>
    </Box>
  );
};

export default PageListItem;
